import React, { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ProjectDetails.css";
import Nav from "../Nav/Nav";
import DescriptionProject from "../DescriptionProject/DescriptionProject";
import ProjectGallery from "../ProjectGallery/ProjectGallery";
import DrawerProject from "../DrawerProject/DrawerProject";
import Footer from "../Footer/Footer";
import projectsData from "../../data/projects.json";

const ProjectDetails = () => {

  const { projectId } = useParams();        
  const navigate = useNavigate();

  const [project, setProject] = useState(null);
  const [allProjects, setAllProjects] = useState([]);

  useEffect(() => {
    if (!projectId || projectsData.length === 0) return;

    const foundProject = projectsData.find(
      (p) => String(p.project_id) === String(projectId)
    );

    if (foundProject) {
      setProject(foundProject);
    } else {
      console.error(`Project with ID ${projectId} not found`);
    }
  }, [projectId]);

  
  useEffect(() => {
    setAllProjects(projectsData);
  }, []);



  const descriptionRef = useRef(null);
  const [isCardVisible, setIsCardVisible] = useState(true);
  const [isCardMinimized, setIsCardMinimized] = useState(false);
  const [isDrawerProjectOpen, setIsDrawerProjectOpen] = useState(false);

  const scrollToDescription = () => {
    const descriptionSection = document.getElementById("description-section");
    if (descriptionSection) {
      descriptionSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleCloseCard = () => {
    setIsCardMinimized(true);
    setTimeout(() => {
      setIsCardVisible(false);
    }, 600);
  };

  const handleExpandCard = () => {
    setIsCardVisible(true);
    setTimeout(() => {
      setIsCardMinimized(false);
    }, 100);
  };

 const [isAlbanian, setIsAlbanian] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      localStorage.setItem('language', JSON.stringify(newLanguage));
      return newLanguage;
    });
  };

  const handleNavigate = (targetProjectId) => {
    if (targetProjectId) {
      navigate(`/vilalproject/${targetProjectId}`);
    }
  };

  const getNextProjectId = () => {
    if (!project || !allProjects.length) return null;
    const currentIndex = allProjects.findIndex(
      (p) => String(p.project_id) === String(project.project_id)
    );
    const nextIndex = (currentIndex + 1) % allProjects.length;
    return allProjects[nextIndex]?.project_id;
  };

  const getPrevProjectId = () => {
    if (!project || !allProjects.length) return null;
    const currentIndex = allProjects.findIndex(
      (p) => String(p.project_id) === String(project.project_id)
    );
    const prevIndex = (currentIndex - 1 + allProjects.length) % allProjects.length;
    return allProjects[prevIndex]?.project_id;
  };

  if (!project) {
    return <div className="loading-screen">Loading project...</div>;
  }

  return (
    <>
    <div className="projectdetails-container-up">
      <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />
      <div className="projectdetails-container">
      {getNextProjectId() && (
            <button 
              className="next-button-outside" 
              onClick={() => handleNavigate(getNextProjectId())}
            >
              <img src="/nextup.png" alt="Next" className="nextPro-btn-img"/>
            </button>
          )}

          {getPrevProjectId() && (
            <button 
              className="prevTop-button-outside" 
              onClick={() => handleNavigate(getPrevProjectId())}
            >
              <img src="/prevup.png" alt="Prev" className="prevProTop-btn-img"/>
            </button>
          )}

        <img
          src={project.project_image_url}
          alt="projectdetails-photo"
          className="projectdetails-image"
        />
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="hero-title">
            {isCardVisible && !isCardMinimized && (
              <div className="card">
                <button className="close-btn" onClick={handleCloseCard}>
                  &times;
                </button>
                <div className="cardproject-left">
                  <p className="card-location">
                    {isAlbanian ? project.adresa_projekti : project.project_address}
                  </p>
                  <h3
  className="card-title"
  style={{
    fontSize: "30px",
  }}
>
  {isAlbanian ? project.titulli_projekti : project.project_title}
</h3>
                </div>
                <div className="card-actions">
                  <button
                    className="card-action-btn"
                    onClick={() => setIsDrawerProjectOpen(true)}
                  >
                    {isAlbanian ? "Të dhënat e projektit" : "Project details"}
                  </button>

                  <div className="separator"></div>
                  <button
                    className="card-action-btn secondary"
                    onClick={scrollToDescription}
                  >
                    {isAlbanian ? "Përshkrimi" : "Description"}
                  </button>
                </div>
              </div>
            )}
            {isCardMinimized && (
              <div className="card-minimized" onClick={handleExpandCard}>
                <div className="dots">••••••</div>
              </div>
            )}
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
      <div ref={descriptionRef}>
        <DescriptionProject isAlbanian={isAlbanian} projectId={projectId} />
      </div>
      <ProjectGallery isAlbanian={isAlbanian} projectId={projectId} />
      <DrawerProject
        isAlbanian={isAlbanian}
        projectId={projectId}
        isOpen={isDrawerProjectOpen}
        onClose={() => setIsDrawerProjectOpen(false)}
      />
     
    </div>
    <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default ProjectDetails;
